import { convertAmount } from './utils'


function array2col(csvobj, colname) {
    // Takes an array an separetes it in individual columns
    var arr = [];
    // Convert an object to an array - in reverse order
    for (var i = 0; i < csvobj.length; i++) {
        if ([2, 3, 4].indexOf(colname) !== -1) {
            if (typeof csvobj[i][colname] === 'string') {
                arr.push(parseFloat(csvobj[i][colname].replace(/,/g, "")));
            } else {
                arr.push(csvobj[i][colname]);
            }
        } else {
            arr.push(csvobj[i][colname]);
        }
    }
    return arr;
}

function glcalc(csvobj, ob) {
    // Handle currency gain loss ob='Opening balance'
    // convert csvobj items into separate lists for foamount, rate, fuamount, etc.

    var fx = {
        date: array2col(csvobj, 0),
        description: array2col(csvobj, 1),
        foamount: array2col(csvobj, 2),
        rate: array2col(csvobj, 3),
        fuamount: array2col(csvobj, 4),
        gainfuamount: [],
        positive: [],
        negative: [],
    };
    for (let i = 0; i < fx.foamount.length; i++) {
        // Separate + and - into different lists
        if (fx.foamount[i] > 0) {
            fx.positive.push([fx.foamount[i], fx.rate[i], fx.fuamount[i]]);
            fx.negative.push(0);
        } else {
            fx.positive.push(0);
            fx.negative.push([fx.foamount[i], fx.rate[i], fx.fuamount[i]]);
        }
        fx.gainfuamount.push([]);
    }
    if (typeof ob == 'object' && ob.length > 0) {
        //console.log('opening balance' + JSON.stringify(ob));
        for (let i = 0; i < ob.length; i++) {
            if (ob[i][2].length === 0) {
                continue;
            }
            if (parseFloat(ob[i][2]) > 0.0) {
                fx.positive.unshift([parseFloat(ob[i][2]), ob[i][3], ob[i][4]]);
                fx.negative.unshift(0);
            } else {
                fx.positive.unshift(0);
                fx.negative.unshift([parseFloat(ob[i][2]), ob[i][3], ob[i][4]]);
            }
            fx.gainfuamount.unshift([]);
            fx.rate.unshift(parseFloat(ob[i][3]));
            fx.description.unshift(ob[i][1]);
            fx.date.unshift(ob[i][0]);
            fx.foamount.unshift(parseFloat(ob[i][2]));
            fx.fuamount.unshift(parseFloat(ob[i][2]) * parseFloat(ob[i][3]));
        }
    }

    // Reverse the relevant arrays for the calculation (to enforce FIFO order from oldest to newest)
    fx.date.reverse();
    fx.description.reverse();
    fx.foamount.reverse();
    fx.rate.reverse();
    fx.fuamount.reverse();
    fx.positive.reverse();
    fx.negative.reverse();
    fx.gainfuamount.reverse();

    //console.log('>>>>>>>>>>>><<<<<<<<<<<<');
    for (let i = 0; i < fx.negative.length; i++) {
        // There are 3 cases
        if (fx.negative[i] !== 0) {
            for (let j = 0; j < fx.positive.length; j++) {
                if (fx.positive[j] !== 0) {
                    if (Math.abs(fx.negative[i][0]) < fx.positive[j][0]) {
                        fx.positive[j][0] += fx.negative[i][0];
                        fx.gainfuamount[i].push(fx.negative[i][0] * fx.rate[i] - fx.negative[i][0] * fx.rate[j]);
                        fx.negative[i] = 0;
                        break;
                    } else if (Math.abs(fx.negative[i][0]) === fx.positive[j][0]) {
                        /* this calculation needs to be revisited */
                        //console.log(fx.date[i] + ' Math.abs(fx.negative[i][0]) === Math.abs(fx.positive[j][0]):: +ve ' + fx.positive[j] + ' : -ve ' + fx.negative[i]);
                        //console.log('    REVISIT THIS:: ' + fx.negative[i][0] * fx.negative[i][1] + ' - ' + fx.negative[i][0] * fx.positive[j][1]);
                        fx.gainfuamount[i].push(fx.negative[i][0] * fx.rate[i] - fx.negative[i][0] * fx.rate[j]);
                        fx.positive[j] = 0;
                        fx.negative[i] = 0;
                        //console.log('-ve ' + fx.negative[i] + ', +ve ' + fx.positive[j] + ', gain ' + fx.gainfuamount[i]);
                        break;
                    } else if (Math.abs(fx.negative[i][0]) > fx.positive[j][0]) {
                        fx.negative[i][0] += fx.positive[j][0];
                        fx.negative[i][2] += fx.positive[j][0] * fx.rate[i];
                        fx.gainfuamount[i].push(fx.positive[j][0] * fx.rate[j] - fx.positive[j][0] * fx.rate[i]);
                        fx.positive[j] = 0;
                    }
                }
            }
        }
    }

    // Reverse them back again for the final output (newest first)
    fx.date.reverse();
    fx.description.reverse();
    fx.foamount.reverse();
    fx.rate.reverse();
    fx.fuamount.reverse();
    fx.positive.reverse();
    fx.negative.reverse();
    fx.gainfuamount.reverse();

    var fxret = [];
    var fxbalance = [];
    for (let i = 0; i < fx.date.length; i++) {
        let gains = fx.gainfuamount[i].reduce((acc, val) => acc + val, 0);
        fxret.push({
            date: fx.date[i],
            description: fx.description[i],
            amount: fx.foamount[i],
            rate: fx.rate[i],
            functional_amount: fx.fuamount[i],
            gainloss: gains,
        });
        fxbalance.push([fx.positive[i], fx.negative[i]]);
    }
    //console.log(fxret);
    //console.log(fxbalance);
    return [fxret, fxbalance];
}

export function calculateGainLoss(csvdata, ob) {
    var [gltable, cbalance] = glcalc(csvdata, ob);

    // now fill in the closing balance by extracting the data from positive array
    let cb = []
    for (var i = 0; i < cbalance.length; i++) {
        //TODO: is it impossible for both to be > 0 at the same time?
        if (cbalance[i][0] !== 0 && cbalance[i][1] === 0) {
            let fuamount = cbalance[i][0][0] * cbalance[i][0][1];
            cb.push([gltable[i].date, gltable[i].description, convertAmount(cbalance[i][0][0], 2), convertAmount(cbalance[i][0][1], 6), convertAmount(fuamount, 6)]);
        } else if (cbalance[i][1] !== 0 && cbalance[i][0] === 0) {
            let fuamount = cbalance[i][1][0] * cbalance[i][1][1];
            cb.push([gltable[i].date, gltable[i].description, convertAmount(cbalance[i][1][0], 2), convertAmount(cbalance[i][1][1], 6), convertAmount(fuamount, 6)]);
        } else if (cbalance[i][1] === 0 && cbalance[i][0] === 0) {
            //console.log("cbalance[i][1] == 0 && cbalance[i][0] == 0")
        } else {
            //console.log('ERROR: Take care of this case');
            //console.log(cbalance[i][0], cbalance[i][1]);
        }

    }
    return [gltable, cb];
}
